<template>
  <page>
    <template slot="content">
      <q-and-a-content :title="'毎日ミッション'">
        <template slot="content">
          <div class="text">毎日配布される日替わりミッションが「ホーム」に表示されます。ミッションは1日一つだけです。ミッションを完了させると、Weマイルが進呈されます。ミッションは内容の難易度によってマイルが異なります。</div>
          <img class="picture" src="../assets/images/q_and_a/9.png">
          <img class="picture" src="../assets/images/q_and_a/10.png">
        </template>
      </q-and-a-content>
    </template>
  </page>
</template>

<script>
  import Page from '@/components/Page'
  import QAndAContent from '@/components/QAndAContent.vue'

  export default {
    name: 'QAndADailyMission',
    components: {
      Page,
      QAndAContent
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesDailyMission.vue